<template>
  <v-main class="bg-primary main-alto" color="primary">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" class="text-center">
          <v-img
            src="/assets/logo-hc-white.png"
            max-height="200"
            max-width="200"
            contain
            class="mx-auto !important"
            alt="HC Logo"
          ></v-img>
        </v-col>
      </v-row>
      <v-row>
        <Login />
      </v-row>
    </v-container>
  </v-main>
</template>

<script setup>
import Login from './Login.vue'
import { defineComponent } from 'vue'

defineComponent({
  name: 'LoginLayout'
})
</script>

<style scoped>
.main-alto {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
